<template lang="pug">
ul.user-list(:class="userClass")
  li.user-item(v-for="{ userId, userName, disabled, label } in userInfoList", :key="userId")
    label(:title="label", @click="clickItem(userId)")
      .pull-right
        slot(name="right")
          i.delete.el-icon-delete(v-if="!disabled", @click.stop="deleteUserId(userId)")
      slot(:nodeId="userId")
      img.avatar(v-if="avatar", :src="userId | avatar")
      | {{ label }}
</template>
<script>
import { gettouxAvatar } from "@/CommonDP/utils";
export default {
  filters: {
    avatar(id) {
      return gettouxAvatar(id);
    }
  },
  inheritAttrs: false,
  props: {
    list: { default: () => [], type: Array },
    disabled: { type: Boolean, default: false },
    line: { type: String, default: "block" },
    avatar: { type: Boolean, default: true },
    jobNo: { type: Boolean, default: true }
  },
  computed: {
    userInfoList() {
      const { list = [], disabled, jobNo } = this;
      return list.map((item) => {
        let label = item.name;
        const userName = item.username || item.userName;
        if (jobNo && userName) label += `(${userName})`;
        return {
          ...item,
          label,
          disabled: disabled || item.pin
        };
      });
    },
    userClass() {
      const { avatar, line } = this;
      return { "hide-avatar": !avatar, [line]: true };
    }
  },
  methods: {
    deleteUserId(id) {
      this.$emit("delete", id);
    },
    clickItem(id) {
      const li = this.list.find(({ userId }) => userId === id);
      this.$emit("click-item", li);
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
